import { createContext, useContext } from 'react';
const initialValue = {};
export const CrmMessagingContext = /*#__PURE__*/createContext(initialValue);
export function useCrmMessagingContext() {
  return useContext(CrmMessagingContext);
}